import { useEffect, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { decryptData } from "../../../utils/encrypt";
import _ from "underscore";
import { dateConvert } from "../../../utils/Helper";

export const useTopCpuQueries = ({ projectChanged }) => {


    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState(false)
    const sessionCols = [
        {
            key: "session_id",
            label: "Session Id",
            headerStyle: { textAlign: "center" },
            style: { width: "5%", textAlign: "center" },

        },
        {
            key: "kill_command",
            label: "Kill Command",
            style: { width: "10%" },
        },
        {
            key: "object_name",
            label: "Object Name",
            style: { width: "20%" },
            render: (row) => <span className="font-semibold">{row?.object_name}</span>
        },
        {
            key: "start_time",
            label: "Start Time",
            style: { width: "10%" },
            render: (row) => {
                return (
                    <div className="py-1">
                        {row?.start_time ? dateConvert(row?.start_time, "date-time-months") : "-"}
                    </div>
                )
            }
        },
        {
            key: "cpu_time_ms",
            label: "CPU Time (ms)",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "10%" },
            render: (row) => <span>{row?.cpu_time_ms?.toLocaleString() || 0}</span>
        },
        {
            key: "cpu_time_sec",
            label: "CPU Time (sec)",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "10%" },
        },

        {
            key: "statement_text",
            label: "Statement Text",
            style: { width: "35%" },
            render: (row) => {
                return (
                    <div
                        title={row?.statement_text}
                        className="truncate max-w-xs text-xs text-gray-600"
                    >
                        {row?.statement_text}
                    </div>
                )
            }
        },
    ];


    useEffect(() => {
        getTopCpuQueries()
    }, [projectChanged])

    useEffect(() => {
        const interval = setInterval(() => {
            getTopCpuQueries();
        }, 120000);

        return () => clearInterval(interval);
    }, []);

    const getTopCpuQueries = async () => {
        try {
            const selectedProject = sessionStorage.getItem("inspectra_project") ? JSON.parse(decryptData(sessionStorage.getItem("inspectra_project"))) : {};
            if (!_.isEmpty(selectedProject)) {
                setLoader(true)
                const payload = {
                    "project_id": selectedProject?.project_id
                }
                const response = await services.getInvokeRemote("POST", Urls("GETTOPCPUQUERIES"), payload);
                if (response?.body?.data?.cpu_queries) {
                    setRowData(response?.body?.data?.cpu_queries)
                } else {
                    setRowData([])
                }
                setLoader(false)
            }

        } catch (error) {
             setLoader(false)
            console.error("error::", error)
        }
    }

    return {
        sessionCols,
        rowData,
        loader
    }
}